module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-2-en-CA-528716254659e720d89df5ce63ee04dd.png";